import { useState, useEffect, useContext } from 'react';
import { Box, Button, Modal, ModalDialog, ModalClose, Typography } from '@mui/joy';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import { AppContext } from '../context';
import { APIGetStudioSettings } from '../api';

// Кнопка «Показать QR-код» у фотографа. QR берётся из настроек студии.
// Если QR не загружен — кнопка не показывается.
export default function QrCodeButton() {
    const { token } = useContext(AppContext);
    const [qrUrl, setQrUrl] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        let alive = true;
        (async () => {
            const data = await APIGetStudioSettings(token);
            if (alive) setQrUrl(data?.qr_url || null);
        })();
        return () => { alive = false; };
    }, [token]);

    if (!qrUrl) return null;

    return (
        <>
            <Button
                fullWidth size="lg"
                onClick={() => setOpen(true)}
                startDecorator={<QrCode2RoundedIcon sx={{ fontSize: 20 }} />}
                sx={{
                    background: 'linear-gradient(135deg, var(--joy-palette-primary-500) 0%, var(--joy-palette-primary-300) 100%)',
                    color: '#fff', fontWeight: 800, fontSize: 14,
                    boxShadow: '0 4px 16px rgba(162,38,226,0.35)',
                    py: 1.6, borderRadius: 'var(--joy-radius-xl)', mb: 2,
                }}
            >
                Показать QR-код
            </Button>

            <Modal open={open} onClose={() => setOpen(false)}
                slotProps={{ backdrop: { sx: { backdropFilter: 'blur(6px)', bgcolor: 'rgba(0,0,0,0.85)' } } }}>
                <ModalDialog sx={{
                    bgcolor: '#fff', p: { xs: 2, sm: 3 }, borderRadius: 'var(--joy-radius-xl)',
                    width: '96vw', maxWidth: 560, maxHeight: '96vh',
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                }}>
                    <ModalClose />
                    <Typography sx={{ fontSize: 16, fontWeight: 800, color: '#111', mb: 1.5 }}>
                        Наведи камеру на QR-код
                    </Typography>
                    <Box component="img" src={qrUrl} alt="QR"
                        sx={{ width: '100%', maxWidth: 460, height: 'auto', objectFit: 'contain' }} />
                </ModalDialog>
            </Modal>
        </>
    );
}